import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { TextSize, TextSkin, TextWeight } from './Text.types';

export const textUniDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Get the root element's tagName
     * @return {Promise<string>} html tagName
     */
    getTagName: async (): Promise<string> =>
      (await base._prop('tagName')).toLowerCase(),

    /**
     * Get text content (innerHTML)
     * @return {Promise<string>} innerHTML content
     */
    getText: (): Promise<string> => base._prop('innerHTML'),

    /**
     * Get size
     * @return {Promise<'tiny' | 'small' | 'medium'>}
     */
    getSize: () => base.attr('data-size') as Promise<TextSize>,

    /**
     * Get skin
     * @return {Promise<'standard'| 'error'| 'success'| 'premium'| 'disabled'>}
     */
    getSkin: () => base.attr('data-skin') as Promise<TextSkin>,

    /**
     * Get weight
     * @return {Promise<'thin' | 'normal' | 'bold'>}
     */
    getWeight: () => base.attr('data-weight') as Promise<TextWeight>,

    /**
     * Get id
     * @return {Promise<string>}
     */
    getId: () => base.attr('id') as Promise<string>,

    /**
     * Is light
     * @return {Promise<boolean>}
     */
    isLight: async () => (await base.attr('data-light')) === 'true',

    /**
     * Is secondary
     * @return {Promise<boolean>}
     */
    isSecondary: async () => (await base.attr('data-secondary')) === 'true',

    /**
     * Checks if component has masking classNames
     * @return {Promise<boolean>}
     */
    isMasked: async () => (await base.attr('data-mask')) === 'true',

    /**
     * Checks if the text is using &nbsp;
     * @return {Promise<boolean>}
     */

    isWidows: async () => (await base.attr('data-widows')) === 'true',
  };
};

export type TextUniDriver = ReturnType<typeof textUniDriverFactory>;
